import React from "react";
import "../assets/css/AboutSection.css";
import img from '../assets/imgs/online-classroom.jpg'

export default function AboutSection() {
    return (
        <main className="am-about-page" id="about">

            {/* HERO */}
            <section className="am-about-hero">
                <h1 className="am-about-title">About Aabhyas Mitra</h1>
                <div className="am-hero-left">

                    <div className="am-about-hero-img">
                        <img src={img}></img>
                    </div>
                </div>

                <div className="am-hero-right">

                    <p className="am-about-subtitle">
                        Empowering students of classes 8th–10th with structured guidance,
                        technology-driven learning, and trusted academic mentorship.
                    </p>
                </div>
            </section>

            {/* VISION & MISSION */}
            <section className="am-about-section">
                <div className="am-about-grid">
                    <div className="am-about-card">
                        <h2 className="am-about-heading">Our Vision</h2>
                        <p>
                            To become India’s most trusted academic support ecosystem,
                            enabling every student to reach their true potential
                            irrespective of geography or background.
                        </p>
                    </div>

                    <div className="am-about-card">
                        <h2 className="am-about-heading">Our Mission</h2>
                        <p>
                            To simplify learning through expert counselling, disciplined
                            practice, real-time monitoring, and transparent academic systems
                            for students, parents, and educators.
                        </p>
                    </div>
                </div>
            </section>

            {/* DIRECTOR MESSAGE */}
            <section className="am-about-director">
                <div className="am-about-director-content">
                    <h2 className="am-about-heading">Message from the Director</h2>
                    <p>
                        “Education today needs more than classrooms. It needs mentors,
                        structure, accountability, and technology. Aabhyas Mitra was
                        created to bridge the gap between effort and achievement.
                        We believe every child deserves guided practice, timely support,
                        and confidence in their learning journey.”
                    </p>
                    <span className="am-about-director-name">
                        — Director, Aabhyas Mitra
                    </span>
                </div>
            </section>

            {/* JOURNEY TIMELINE */}
            {/* <section className="am-about-section">
                <h2 className="am-about-heading center">Our Journey</h2>

                <div className="am-about-timeline">
                    <div className="am-about-timeline-item">
                        <span>2022</span>
                        <p>Conceptualisation of Aabhyas Mitra ecosystem</p>
                    </div>

                    <div className="am-about-timeline-item">
                        <span>2023</span>
                        <p>Onboarding of educational counsellors & pilot admissions</p>
                    </div>

                    <div className="am-about-timeline-item">
                        <span>2024</span>
                        <p>Launch of digital admissions, tracking & payment systems</p>
                    </div>

                    <div className="am-about-timeline-item">
                        <span>2025</span>
                        <p>Expansion through franchise & aabhyasika network</p>
                    </div>
                </div>
            </section> */}

            {/* EDUCATIONAL PHILOSOPHY */}
            <section className="am-about-philosophy">
                <h2 className="am-about-heading">Our Educational Philosophy</h2>

                <div className="am-about-philosophy-grid">
                    <div className="am-about-pill">Concept Clarity</div>
                    <div className="am-about-pill">Daily Practice</div>
                    <div className="am-about-pill">Mentor Accountability</div>
                    <div className="am-about-pill">Student Discipline</div>
                    <div className="am-about-pill">Parent Transparency</div>
                    <div className="am-about-pill">Result-Oriented Learning</div>
                </div>
            </section>

            {/* CSR / PRESS */}
            {/* <section className="am-about-section">
                <h2 className="am-about-heading center">Beyond Academics</h2>
                <p className="am-about-text center">
                    Aabhyas Mitra actively supports education accessibility through
                    counselling programs, merit-based support initiatives, and
                    partnerships with local academic communities.
                </p>

                <div className="am-about-links">
                    <a href="#" className="am-about-link">CSR Initiatives</a>
                    <a href="#" className="am-about-link">Press & Media</a>
                </div>
            </section> */}

        </main>
    );
}
